import type { JSX, ParentComponent } from "solid-js";
import { Dynamic } from "solid-js/web";
import "./MonoText.css";

/** Maps to `--colour-fg-*` and `--gvt-primary` in shared-core.css */
export type MonoTextColor = "fg1" | "fg2" | "fg3" | "fg4" | "primary";

type Props = {
	as?: "div" | "span" | "p";
	class?: string;
	classList?: Record<string, boolean>;
	style?: JSX.CSSProperties;
	title?: string;
	color?: MonoTextColor;
};

export const MonoText: ParentComponent<Props> = (props) => {
	const classList = () => ({
		...props.classList,
		[`gvtui-mono-text--color-${props.color}`]: props.color !== undefined,
	});

	return (
		<Dynamic
			component={props.as ?? "div"}
			class={`gvtui-mono-text ${props.class ?? ""}`}
			classList={classList()}
			style={props.style}
			title={props.title}
		>
			{props.children}
		</Dynamic>
	);
};
